//CKAPISIZ;446187;18032025
export interface ProcedureItem {
  id: number;
  name: string;
  value: number;
  urgent: boolean;
}

export interface DiagnosticCategory {
  id: number;
  category: string;
  expanded: boolean;
  procedures: ProcedureItem[];
}

export const diagnosticData: DiagnosticCategory[] = [
  {
    id: 1,
    category: "Nonoperatif",
    expanded: false,
    procedures: [
      { id: 101, name: "Diyabetik Ketoasidoz", value: -150.04, urgent: false },
      { id: 102, name: "Diyabetik Ketoasidoz", value: -150.04, urgent: false },
    ],
  },
  {
    id: 2,
    category: "Kardiyovasküler Yetmezlik",
    expanded: false,
    procedures: [
      { id: 103, name: "Diyabetik Ketoasidoz", value: -150.04, urgent: false },
    ],
  },
];
